<div class="preview-container">
  <div class="preview-content">
    <!-- Loading Overlay -->
    <div class="preview-loader" *ngIf="isLoading">
      <div class="loader-content">
        <div class="spinner"></div>
        <p>Loading preview...</p>
      </div>
    </div>
    
    <!-- Preview Placeholder when no template selected -->
    <div class="preview-placeholder" *ngIf="!hasTemplateSelected">
      <div class="placeholder-content">
        <i class="fas fa-eye"></i>
        <p>Select a template to see your website preview</p>
      </div>
    </div>
    
    <!-- Website Preview iframe -->
    <iframe 
      #previewFrame
      *ngIf="hasTemplateSelected"
      frameborder="0"
      class="preview-iframe"
      allow="scripts"
      sandbox="allow-scripts allow-same-origin allow-forms"
      (load)="onIframeLoad()">
    </iframe>
  </div>
</div> 